/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as CounterpartiesRouteImport } from './routes/counterparties'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginCallbackRouteImport } from './routes/login.callback'
import { Route as InvoicesNewRouteImport } from './routes/invoices.new'
import { Route as InvoicesIdRouteImport } from './routes/invoices.$id'
import { Route as CounterpartiesNewRouteImport } from './routes/counterparties.new'
import { Route as CounterpartiesIdRouteImport } from './routes/counterparties.$id'
import { Route as CounterpartiesIdEditRouteImport } from './routes/counterparties.$id.edit'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const CounterpartiesRoute = CounterpartiesRouteImport.update({
  id: '/counterparties',
  path: '/counterparties',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCallbackRoute = LoginCallbackRouteImport.update({
  id: '/login/callback',
  path: '/login/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesNewRoute = InvoicesNewRouteImport.update({
  id: '/invoices/new',
  path: '/invoices/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIdRoute = InvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CounterpartiesNewRoute = CounterpartiesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => CounterpartiesRoute,
} as any)
const CounterpartiesIdRoute = CounterpartiesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CounterpartiesRoute,
} as any)
const CounterpartiesIdEditRoute = CounterpartiesIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => CounterpartiesIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/counterparties': typeof CounterpartiesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/counterparties/$id': typeof CounterpartiesIdRouteWithChildren
  '/counterparties/new': typeof CounterpartiesNewRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/login/callback': typeof LoginCallbackRoute
  '/counterparties/$id/edit': typeof CounterpartiesIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/counterparties': typeof CounterpartiesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/counterparties/$id': typeof CounterpartiesIdRouteWithChildren
  '/counterparties/new': typeof CounterpartiesNewRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/login/callback': typeof LoginCallbackRoute
  '/counterparties/$id/edit': typeof CounterpartiesIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/counterparties': typeof CounterpartiesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/counterparties/$id': typeof CounterpartiesIdRouteWithChildren
  '/counterparties/new': typeof CounterpartiesNewRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/login/callback': typeof LoginCallbackRoute
  '/counterparties/$id/edit': typeof CounterpartiesIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/counterparties'
    | '/settings'
    | '/counterparties/$id'
    | '/counterparties/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/login/callback'
    | '/counterparties/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/counterparties'
    | '/settings'
    | '/counterparties/$id'
    | '/counterparties/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/login/callback'
    | '/counterparties/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/counterparties'
    | '/settings'
    | '/counterparties/$id'
    | '/counterparties/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/login/callback'
    | '/counterparties/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CounterpartiesRoute: typeof CounterpartiesRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  InvoicesIdRoute: typeof InvoicesIdRoute
  InvoicesNewRoute: typeof InvoicesNewRoute
  LoginCallbackRoute: typeof LoginCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/counterparties': {
      id: '/counterparties'
      path: '/counterparties'
      fullPath: '/counterparties'
      preLoaderRoute: typeof CounterpartiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/callback': {
      id: '/login/callback'
      path: '/login/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof LoginCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/new': {
      id: '/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof InvoicesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/$id': {
      id: '/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof InvoicesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/counterparties/new': {
      id: '/counterparties/new'
      path: '/new'
      fullPath: '/counterparties/new'
      preLoaderRoute: typeof CounterpartiesNewRouteImport
      parentRoute: typeof CounterpartiesRoute
    }
    '/counterparties/$id': {
      id: '/counterparties/$id'
      path: '/$id'
      fullPath: '/counterparties/$id'
      preLoaderRoute: typeof CounterpartiesIdRouteImport
      parentRoute: typeof CounterpartiesRoute
    }
    '/counterparties/$id/edit': {
      id: '/counterparties/$id/edit'
      path: '/edit'
      fullPath: '/counterparties/$id/edit'
      preLoaderRoute: typeof CounterpartiesIdEditRouteImport
      parentRoute: typeof CounterpartiesIdRoute
    }
  }
}

interface CounterpartiesIdRouteChildren {
  CounterpartiesIdEditRoute: typeof CounterpartiesIdEditRoute
}

const CounterpartiesIdRouteChildren: CounterpartiesIdRouteChildren = {
  CounterpartiesIdEditRoute: CounterpartiesIdEditRoute,
}

const CounterpartiesIdRouteWithChildren =
  CounterpartiesIdRoute._addFileChildren(CounterpartiesIdRouteChildren)

interface CounterpartiesRouteChildren {
  CounterpartiesIdRoute: typeof CounterpartiesIdRouteWithChildren
  CounterpartiesNewRoute: typeof CounterpartiesNewRoute
}

const CounterpartiesRouteChildren: CounterpartiesRouteChildren = {
  CounterpartiesIdRoute: CounterpartiesIdRouteWithChildren,
  CounterpartiesNewRoute: CounterpartiesNewRoute,
}

const CounterpartiesRouteWithChildren = CounterpartiesRoute._addFileChildren(
  CounterpartiesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CounterpartiesRoute: CounterpartiesRouteWithChildren,
  SettingsRoute: SettingsRoute,
  InvoicesIdRoute: InvoicesIdRoute,
  InvoicesNewRoute: InvoicesNewRoute,
  LoginCallbackRoute: LoginCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
